import React from 'react'

const ViewsIcon = () => {
    return (
        <svg className='views-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <path
                className="vicon"
                d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12Z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle className="vicon" cx="12" cy="12" r="3.25" stroke="currentColor" strokeWidth="1.8" />
        </svg>
    )
}

export default ViewsIcon
